import { FilledHeader } from 'components/PageStructure'
import styled from 'styled-components'

const Title = styled.h1`
  margin-top: 1.25rem;
  padding: 0 1.875rem;
`

const StyledFilledHeader = styled(FilledHeader)`
  margin-top: 2rem;
`

const LoadingSpinnerContainer = styled.div`
  display: flex;
  padding-top: 12rem;
  justify-content: center;
  svg {
    height: 126px;
  }
`

const DataContainer = styled.div`
  width: 26rem;
  padding: 0 1.875rem;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

export { Title, StyledFilledHeader, LoadingSpinnerContainer, DataContainer, ButtonContainer }
